import './file-input.directive.ajscss';

import templateUrl from './file-input.directive.html';

export let FileInputDirective = [
  '$q',
  $q => ({
    restrict: 'E',
    templateUrl,
    require: 'ngModel',
    scope: {
      file: '=ngModel',
      htmlId: '@?',
      htmlName: '@?',
      htmlAccept: '@?',
    },
    link: (scope, element) => {
      scope.$watch('file', newValue => {
        if (newValue == null || newValue === '') {
          scope.name = '';
          element[0].children[0].children[2].value = null;
        }
      });

      element.bind('change', e => {
        scope.name = '';
        let elem = e.target;

        $q.all(Array.prototype.slice.call(elem.files, 0).map(readFile)).then(values => {
          scope.file = values[0];
        });

        function readFile(file) {
          let deferred = $q.defer();

          let reader = new FileReader();
          reader.onload = el => {
            scope.name = file.name;
            deferred.resolve(el.target && el.target['result']);
          };
          reader.onerror = err => {
            deferred.reject(err);
          };
          reader.readAsText(file);

          return deferred.promise;
        }
      });
    },
  }),
];

export default 'cngFileInput';
